import { Button, Flex, Form, Input } from '@/components'
import { Layout } from '@/components/layout'
import { Routes } from '@/configs'
import { useInput, useRouting } from '@/hooks'
import { Alert, Api } from '@/modules'
import { SendResetPasswordCodeRequest } from '@shared/models'

export function SendResetPasswordCode() {
  const { navigate } = useRouting()
  const { sendAlert } = Alert.Hook()
  const { value: email, binder: bindEmail, reset: resetEmail } = useInput('')

  const { isRunning: isSendingCode, run: sendCode } = Api.Command<void>(Api.Methods.POST, `auth/send-code`)

  const onSubmit = () => {
    if (!email) {
      alert('Preencha com seu email cadastrado!')
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!emailRegex.test(email)) {
      sendAlert({
        type: 'error',
        title: 'Email inválido',
        message: 'Por favor, forneça um endereço de email válido.',
      })

      return
    }

    const input = {
      email,
    } as SendResetPasswordCodeRequest

    sendCode<SendResetPasswordCodeRequest>({
      input,
      onSuccess: () => onSuccess('Caso tenha enviado um e-mail válido, o código será enviado para o seu e-mail.'),
    })
  }

  const onSuccess = (message: string) => {
    sendAlert({
      type: 'success',
      title: 'Sucesso',
      message,
    })

    resetEmail()

    navigate(Routes.ResetPassword.path, { state: { email } })
  }

  return (
    <Layout.Login>
      <Layout.Padder>
        <Flex $type="row" $justify="center" $align="center" $gap={24} $fit>
          <Form title="Recuperar Senha" onSubmit={onSubmit}>
            <Flex $type="column" $gap={24} style={{ minWidth: '400px' }}>
              <p>Escreva seu email para receber o código de redefinição de senha.</p>
              <Input label="Email" placeholder="Digite seu email" {...bindEmail} required />
            </Flex>
            <Flex $type="column" $gap={12} style={{ minWidth: '400px' }}>
              <Button.Root $variant="primary" style={{ width: '100%' }} type="submit" $loading={isSendingCode}>
                <Button.Text value="Enviar Código" />
              </Button.Root>
              <Button.Root
                $variant="link"
                style={{ width: '100%' }}
                type="button"
                onClick={() => navigate(Routes.Login.path)}>
                <Button.Text value="Voltar" />
              </Button.Root>
            </Flex>
          </Form>
        </Flex>
      </Layout.Padder>
    </Layout.Login>
  )
}
